import { GET_ARMOUR_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ARMOUR_RECIPES_SUCCESS: {
      const armourRecipes = action.payload;

      if (!armourRecipes){
        return [...state];
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
